<template>
<div v-if="show" class="Product-Modal">
    <div @click="closeModal()" class="Product-Modal__outside"></div>
    <div class="Product-Modal__container">
        <div class="mobileContainer">
            <a class="keepShopping" @click="closeModal()">
                <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/back_icon_2x_d91afdf9-cf7f-4f8c-8f62-b042876f9017.png?v=1626358812">
                <span>keep shopping</span>
            </a>
            <a class="closeIcon" @click="closeModal()"><img src="https://cdn.shopify.com/s/files/1/1363/8433/files/x_close_2x_d14359fb-57ed-4525-9bf1-922072b25de0.png?v=1626213420"></a>
        </div>
        <div class="Product-Modal__image">
            <img v-if="totalVariant > 1 && !isClothes" :src="product | getProductVariantImage(selectedVariant)">
            <img v-else :src="selectedImage">
        </div>
        <div v-if="(imageQuantity > 1) && ((totalVariant > 1 && isClothes) || totalVariant == 1)" class="Product__image_container mobileFlex">
            <a @click="selectImage(image.src)" v-for="image in product.images" :key="image.id">
                <img :src="image.src">
            </a>
        </div>
        <div class="Product-Modal__Product">
            <p class="Product__title">{{product.title + selectedVariantTitle | uppperCase}}</p>
            <span class="Product__price">{{product | moneyFormat}}</span>
            <div v-if="totalVariant > 1" class="Product_variant_election">
                <div class="Product__option-container" v-for="option in product.options" :key="option.position">
                    <span>{{option.name}}</span>
                    <div v-if="isClothes" class="btn-group">
                        <button @click="selectOption(value)" v-for="value in option.values" class="Product__option-btn" :class="[value == selectedOption ? 'Product__option-btn--selected' : '' ]" :key="value"><span>{{value}}</span></button>
                    </div>
                    <div v-else class="Product__dot_container">
                        <div @click="selectOption(variant.option1)" v-for="(variant, index) in product.variants" :key="variant.id" class="Product__carousel-dot" v-bind:style="{'background-color': (colorVariants[index] ? colorVariants[index] : '#fff')}" :class="[variant.id == selectedVariant ? 'Product__carousel-dot--selected':'',product.variants[index].available == false ? 'Product__carousel-dot--disabled' : '']">
                            <span v-if="!colorVariants[index]"> {{product.variants[index].title.charAt(0)}} </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="Product__quantity_selector">
                <div class="Product__quantity">
                    <button class="Product__quantity-btn" @click="updateQuantity(false)"><span v-show="productQuantity > 1">-</span><img v-show="productQuantity == 1" src="https://cdn.shopify.com/s/files/1/1363/8433/files/trash.svg?v=1621887722"></button>
                    <span class="Product__quantity-status">{{productQuantity ? productQuantity : "0"}}</span>
                    <button class="Product__quantity-btn" @click="updateQuantity(true)"><span>+</span></button>
                </div>
                <button :disabled="!variantAvailable" class="Product-Modal__button" @click="addToCart()">{{buttonText}}</button>
            </div>
            <span class="Product__description">{{ product | getProductDesc}}</span>
            <div v-if="(imageQuantity > 1) && ((totalVariant > 1 && isClothes) || totalVariant == 1)" class="Product__image_container desktop">
                <a @click="selectImage(image.src)" v-for="image in product.images" :key="image.id">
                    <img :class="[image.src == selectedImage ? 'selected' : '' ]" :src="image.src">
                </a>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios';

export default {
    name: "Modal",
    data(){
        return{
            productQuantity: 1,
            currentImage: ""
        }
    },
  props:{
    product:Object,
    show: Boolean,
    chosenOption: String,
  },
  filters:{
      uppperCase(value){
          if (!value) return '';
          value = value.toString();
          return value.toUpperCase();
      }
  },
  computed: {
    totalVariant(){
      return this.product.variants.length;
    },
    isClothes(){
      return this.product.tags.some(x => x.toLowerCase() == "category_clothing" || x.toLowerCase() == "clothes");
    },
    selectedOption(){
        if (this.chosenOption != ""){
            return this.chosenOption
        }
        else {
            return this.product.options[0].values[0]
        }
    },
    selectedVariant(){
        var variantId    = 0;
        if(this.product.variants.length > 1){
            var variants = this.product.variants;
            variantId = variants.filter(x => x.option1 == this.selectedOption).map(y => y.id)
            variantId = variantId[0];
        }
        if(!variantId || variantId == 0)
        {
            variantId = this.product.variants[0].id;
        }

        return variantId
    },
    selectedVariantTitle(){
        var variantId = this.selectedVariant;
        if(this.product.variants.length > 1){
            var variants = this.product.variants;
            return " - " + variants.find(x => x.id == variantId).title;
        }
        else {
            return ""
        }
    },
    colorVariants(){
      var tags = this.product.tags.filter(x => x.match(/variant/g) || x.match(/Variant/g));
      if(tags.length > 0){
        var sortedTags = tags.sort();
        return sortedTags.map(x => x.split("-")[1]);
      }
    },
    imageQuantity(){
        return this.product.images.length;
    },
    selectedImage(){
        if(this.currentImage == ""){
            return this.product.images[0].src;
        }
        else {
            return this.currentImage;
        }
    },
    variantAvailable(){
      var currentProduct = Object.assign({}, this.product);
      var available = false;
      if(currentProduct.variants.length > 1){
        var variants = currentProduct.variants;
        if (this.selectedVariant)
          available = variants.filter(x => x.id == this.selectedVariant).map(y => y.available)[0];
        else
          available = variants[0].available;
      }
      else {
        available = currentProduct.variants[0].available
      }

      return available
    },
    buttonText(){
        return this.variantAvailable ? "add to cart" : "sold out"
    }
  },
  methods:{
    updateQuantity(increase){
        if(increase){
            this.productQuantity++
        }
        else{
            if(this.productQuantity > 0)
                this.productQuantity--
        }
    },
    addToCart(){
        if(!this.variantAvailable)
            return;
        $(".Product-Modal__button").prop('disabled',true);
        $(".Product-Modal__button").html('adding...');
        axios.post('https://happyboxstore.com/cart/add.js', {items:[{id: this.selectedVariant, quantity: this.productQuantity}]})
        .then(response => response.data)
        .then((data) => {
            let hasCart = localStorage.getItem("cartDate");
            if(!hasCart){
                let newDate = new Date();
                let stringDate = newDate.getFullYear() + "-"+ newDate.getMonth() + "-" + newDate.getDate();
                localStorage.setItem("cartDate",stringDate);
            }
           axios.get('https://happyboxstore.com/cart.js').then(responseCart => responseCart.data)
            .then((data) => {
                $(".Product-Modal__button").prop("disabled",false);
                $(".Product-Modal__button").html('add to cart');
                $('#CartCount').html(data.item_count);
                this.closeModal();
            })
        }).catch(err =>{
            alert('Cannot add qty of product')
            $(".Product-Modal__button").prop("disabled",false);
            $(".Product-Modal__button").html('add to cart');
        })
    },
    selectOption(option){
        this.chosenOption = option;
    },
    selectImage(image){
        this.currentImage = image;
    },
    closeModal(){
        if(this.show)
            this.productQuantity = 1;
            this.chosenOption = "";
            this.currentImage = "";
            this.$emit("closemodal");
    }
  }
};
</script>